import cn from 'classnames';
import React from 'react';

export default React.forwardRef(({ className, isError = false, ...props }, ref) => {
    return <select {...props} ref={ref} className={cn('form-control', className, { error: isError })} />;
});
